import { ApiResult, CrudService, Meta } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'any' })
export class FabricanteNacionalDataService extends CrudService<any> {

  protected url: string;

  constructor(
    @Inject(OPERACAO_API_URL) urlBase: string,
    @Inject(HttpClient) protected httpClient: HttpClient
  ) {
    super(urlBase, httpClient);
    this.url = `${urlBase}/v1/fabricantenacional`;
  }
}
